import i18n from "@i18n";
import TextBoxComponent from "@CubeComponents/form/TextBoxComponent";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import PropTypes from "prop-types";

const useCustomFields = () => {
  const validateFormWithId = (id, template, formValidator) => {
    const rules = [];
    if (!template || !template.length) {
      return true;
    }
    template?.forEach((section) => {
      section.questionFields.forEach((item) => {
        rules.push({ name: `${id}_${item._id}`, value: item.answer?.value });
      });
    });
    let valid = true;
    rules.forEach((rule) => {
      const ruleValid = formValidator?.validate({
        name: rule.name,
        value: rule.value,
      });
      valid = valid && ruleValid;
    });
    return valid;
  };

  return {
    validateFormWithId,
  };
};

export const NomenclatureField = ({ args, field, index, value, handleNomenclatureChange }) => {
  const { t } = i18n;
  if (field.type == "text" || field.type == "number") {
    const char = field.type == "text" ? "A" : "1";
    const placeholderText = field.allowedCharacters ? char.repeat(field.allowedCharacters) : `${char.repeat(3)}...`;
    const htmlAttributes = {};
    if (field.allowedCharacters) {
      htmlAttributes.maxlength = `${field.allowedCharacters}`;
    }
    const handleInput = (e) => {
      const maxLength = field.allowedCharacters;
      if (maxLength && e.value.length > maxLength) {
        e.event.target.value = e.value.slice(0, maxLength);
      }
    };

    return (
      <TextBoxComponent
        id={`${args.id}-${field.type}-${index}`}
        key={`${args.id}-${field.type}-${index}`}
        type={field.type}
        onClick={(e) => e.stopPropagation()}
        value={value}
        placeholder={placeholderText}
        className="flex-1"
        htmlAttributes={htmlAttributes}
        input={handleInput}
        onBlur={(e) => handleNomenclatureChange(e, args, field, index)}
      />
    );
  }
  if (field.type == "single select") {
    return (
      <DropDownListComponent
        id={`${args.id}-${field.type}-${index}`}
        key={`${args.id}-${field.type}-${index}`}
        className="flex-1"
        placeholder={t("Select an option")}
        dataSource={field.options}
        value={value}
        onChange={(e) => handleNomenclatureChange(e, args, field, index)}
      />
    );
  }
};
NomenclatureField.propTypes = {
  args: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,

  field: PropTypes.shape({
    type: PropTypes.oneOf(["text", "number", "single select"]).isRequired,
    allowedCharacters: PropTypes.number,
    options: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.arrayOf(
        PropTypes.shape({
          text: PropTypes.string,
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
      ),
    ]),
    _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    answer: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.object]),
    }),
  }).isRequired,

  index: PropTypes.number.isRequired,

  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  handleNomenclatureChange: PropTypes.func.isRequired,
};

NomenclatureField.defaultProps = {
  value: "",
};
export default useCustomFields;
